import { overloadedOption } from '@ecomm/shared-fp-ts-utils'
import { Map as IMap } from 'immutable'

import type { CommerceToolProducts } from '@ecomm/data-simplisafe-api/parseProduct'
import type { Product } from '@simplisafe/ss-ecomm-data/commercetools/products'

export function parseProducts(
  t: readonly CommerceToolProducts[]
): IMap<string, Product> {
  return t.reduce((acc, node) => {
    const sku = node.masterSku
    return acc.set(sku, {
      '@@type': 'product',
      id: node.id,
      discountedPrice: overloadedOption(node.discountedPrice),
      discountedPriceWithServicePlan: overloadedOption(
        node.discountedPriceWithServicePlan
      ),
      isCartable: node.isCartable,
      isIndeterminatePrice: node.isIndeterminatePrice,
      isOnStock: node.isOnStock,
      isSellable: node.isSellable,
      isViewable: node.isViewable,
      hardwareVersion: node.hardwareVersion,
      masterSku: node.masterSku,
      name: {
        ...node.name
      },
      nodeId: node.nodeId,
      price: node.price,
      productType: node.productType,
      productTypeId: node.productTypeId,
      restockDate: node.restockDate,
      sku: node.sku,
      variants: node.variants
    })
  }, IMap<string, Product>())
}
